import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

import { ViewTransactionHistoryButtonProps } from './types';

export default makeStyles((theme: typeof muiTheme) => ({
    root: {
        textDecoration: 'none' as 'none',
        width: (props: ViewTransactionHistoryButtonProps) => (props.text ? '11rem' : '4rem')
    },
    icon: { alignSelf: 'center' as 'center' },
    linkText: {
        fontSize: '.8rem',
        color: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        wordBreak: 'break-word' as 'break-word',
        textTransform: 'none' as 'none',
        textAlign: 'left' as 'left',
        padding: 0,
        paddingLeft: '.75rem'
    },
    iconButton: { padding: '12px' }
}));